import React from "react";

const AdminPageHeader = ({ title, subtitle, action }) => (
  <div className="admin-page-head">
    <div>
      <h4>{title}</h4>
      {subtitle ? <p>{subtitle}</p> : null}
    </div>
    {action ? <div>{action}</div> : null}
  </div>
);

export default AdminPageHeader;
